import appConfig from "./config";

type EndPoint = {
    PreApprovalFormEndpoint: string;
    PreApprovalFormUpdate: string;
    MappingForm: string;
    CurrencyRate: string;
    Configuration: string;
    GetFormFile: string;
    GetOnBehalf: string;
    GetEmployeeProfile: string;
    ProcessToSAP: string;
    RejectReason: string;
    CancelExpenseClaim: string;
    GetExpenseDownLoadFiles: string;
    SetAttachmentStatus: string;
    GetUserRoles: string;
    GetViewForPendingApproval:string;
    GetViewForMyAccessRoles:string;
    GetAccessRoleList:string;
    GetMassDownloadRequestOptions:string;
    GetDetailType:string;
    GetTransportDetail:string;
    ApproveAccessRoleRequest:string;
    SubmitRequestForAccessRole:string;
    InfoValidityCheck:string;
    SubmitMassDownloadRequest:string;
    GetFunctionEmployee:string;
    GetWorkflow:string;
    GetApprovalMatrix:string;
    GetCountry:string;
    UpdateWorkflowMapping:string;
    GetEmployeeValidity:string;
    GetCPRExpensesEnquiry:string;
    GetCPRExpensesLogEnquiry:string;
    GetCPRExpensesDtlEnquiry:string;
    GetAdminCPRExpensesEnquiry:string;
    ExcelImportTable:string;
    UpdateCPRExpensesDtl:string;
    UpdateCPRExpensesLog:string;
    GetRequestForm:string;
    GetOtherOperatingExpenseType:string;
    UpdateRoleAssignment2:string;
}

const baseUrl = appConfig.connectionString.ws;
const endPoint: EndPoint = {
    PreApprovalFormEndpoint: "/api/getFormDtlSummary",
    PreApprovalFormUpdate: "/api/updateFormDetail",
    MappingForm: "/api/getFormMapping",
    CurrencyRate: "/api/getCurrencyRate",
    Configuration: "/api/getConfig",
    GetFormFile: "/api/getFormFiles",
    GetOnBehalf: `${baseUrl}/api/getOnBehalf`,
    GetEmployeeProfile: `${baseUrl}/api/GetEmployeeProfile`,
    ProcessToSAP: `${baseUrl}/api/processExpensesClaim`,
    RejectReason: `${baseUrl}/api/getReason`,
    CancelExpenseClaim: `${baseUrl}/api/cancelExpensesClaim`,
    GetExpenseDownLoadFiles: `${baseUrl}/api/download_file`,
    SetAttachmentStatus: `${baseUrl}/api/setAttachmentStatus`,
    GetUserRoles: `${baseUrl}/api/getUserRoles`,
    GetViewForPendingApproval:`/api/GetViewForPendingApproval`,
    GetViewForMyAccessRoles:`/api/GetViewForMyAccessRoles`,
    GetAccessRoleList:`/api/GetAccessRoleList`,
    ApproveAccessRoleRequest:`/api/ApproveAccessRoleRequest`,
    SubmitRequestForAccessRole:`/api/SubmitRequestForAccessRole`,
    InfoValidityCheck:`/api/InfoValidityCheck`,
    GetMassDownloadRequestOptions:`/api/getMassDownloadRequestOptions`,
    GetDetailType:`/api/getDetailType`,
    GetTransportDetail:`/api/getTransportType`,
    SubmitMassDownloadRequest:`/api/submitMassDownloadRequest`,
    GetFunctionEmployee:`/api/getFunctionEmployee`,
    GetWorkflow:`/api/getWorkflow`,
    GetApprovalMatrix:`/api/getApprovalMatrix`,
    GetCountry:`/api/getCountry`,
    UpdateWorkflowMapping:`/api/updateWorkflowMapping`,
    GetEmployeeValidity: `/api/getEmployeeValidity`,
    GetCPRExpensesEnquiry: `/api/getCPRExpensesEnquiry`,
    GetCPRExpensesLogEnquiry: `/api/getCPRExpensesLogEnquiry`,
    GetCPRExpensesDtlEnquiry: `/api/getCPRExpensesDtlEnquiry`,
    GetAdminCPRExpensesEnquiry: `/api/getAdminCPRExpensesEnquiry`,
    ExcelImportTable:`/api/ImportTable`,
    UpdateCPRExpensesDtl:`/api/updateCPRExpensesDtl`,
    UpdateCPRExpensesLog:`/api/updateCPRExpensesLog`,
    GetRequestForm:`${baseUrl}/api/getRequestForm`,
    GetOtherOperatingExpenseType:`/api/getOtherOperatingExpenseType`,
    UpdateRoleAssignment2:`/api/updateRoleAssignment2`,
}

export default endPoint;